import {
  Component,
  AfterViewInit,
  OnInit,
  ChangeDetectionStrategy,
  Renderer2,
} from '@angular/core';
import { LMBrowserUtilService } from '@utils/lm-browser-util.service';

@Component({
  selector: 'lm-keyboard-shortcuts-dialog',
  templateUrl: 'lm-keyboard-shortcuts-dialog.component.html',
  styleUrls: [ 'lm-keyboard-shortcuts-dialog.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LMKeyboardShortcutsDialogComponent implements OnInit, AfterViewInit {

  public isMac: boolean;

  constructor(
    private renderer: Renderer2,
    private lmBrowserUtilService: LMBrowserUtilService,
  ) {
    this.isMac = this.lmBrowserUtilService.isMAC;
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    // Add a class to the overlay to override the opacity
    this.renderer.addClass(document.body, 'lm-overlay');
  }
}
